var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _c("div", { staticClass: "panel-tag" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.__t("ORG_TAG_PUBLISH")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("h5", { staticClass: "frame-heading" }, [
          _vm._v(_vm._s(_vm.__t("PUBLISHED_TTL"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "custom-control custom-checkbox custom-control-inline",
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.org.published,
                  expression: "org.published",
                },
              ],
              staticClass: "custom-control-input",
              attrs: { type: "checkbox", id: "publish" },
              domProps: {
                checked: Array.isArray(_vm.org.published)
                  ? _vm._i(_vm.org.published, null) > -1
                  : _vm.org.published,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.org.published,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.org, "published", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.org,
                          "published",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.org, "published", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-control-label",
                attrs: { for: "publish" },
              },
              [_vm._v(_vm._s(_vm.__t("PUBLISHED")))]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "skeep_sync mt-5" }, [
          _c("h5", { staticClass: "frame-heading" }, [
            _vm._v(_vm._s(_vm.__t("SKEEP_TTL"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "custom-control custom-checkbox custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.org.skeep_sync,
                    expression: "org.skeep_sync",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "skeep_sync" },
                domProps: {
                  checked: Array.isArray(_vm.org.skeep_sync)
                    ? _vm._i(_vm.org.skeep_sync, null) > -1
                    : _vm.org.skeep_sync,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.org.skeep_sync,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.org, "skeep_sync", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.org,
                            "skeep_sync",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.org, "skeep_sync", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "skeep_sync" },
                },
                [_vm._v(_vm._s(_vm.__t("SKEEP_SYNC")))]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-5" }, [
          _c("label", { staticClass: "form-label", attrs: { for: "cts" } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.__t("LOCALES")) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _vm.locales.length > 0
            ? _c(
                "div",
                {},
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        label: "name",
                        options: _vm.locales,
                        filterable: false,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(option.name) +
                                        "\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("small", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.site_code) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2832248463
                      ),
                      model: {
                        value: _vm.active_local,
                        callback: function ($$v) {
                          _vm.active_local = $$v
                        },
                        expression: "active_local",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.__t("CHOICE_LOCALE")) +
                            "\n                    "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }